import React from "react";
import useLoading from "@/components/features/hooks/useLoading";
import Icon from "@/components/Icon";
import {useTranslation} from "react-i18next";
export const LoadingSpin = () => {
    const {t} = useTranslation();
    let element = <div className="loading-container">
        <div className='loading-content'>
            <Icon name={'Loader'} size={36}/>
            <span className="k-loading-text">{t('loading')}</span>
        </div>
    </div>;
    const { loadingState } = useLoading();
    return loadingState.show ? element : null;
}
